import './About.css';

export default function About() {
  return (
    <section id="about" className="about section">
      <div className="container">
        <h2>About Us</h2>
        <div className="about-content">
          <div className="about-text">
            <p className="about-bio">
              We're a husband and wife team based in Adelaide, dedicated to preserving your family's
              most precious moments.
              <br />
              <br />
              The idea for Kids Vids grew from our own project. For a special event, we collated a
              selection of video files and edited them into a video. A friend of ours - who is a
              mother - thought it was a great idea and a service people would want. We would love
              the opportunity to provide the same joy to you that we experienced that first time.
              And every time since.
              <br />
              <br />
              We have shown the video to friends, mailed some copies overseas to family, watched it
              at home and even added to it as the kids grew.
              <br />
              <br />
              One of the best times was watching it with the kids. Showing them what life was like
              before they could remember, back when we were all learning together.
              <br />
              <br />
              With TV production experience including credits on McLeod's Daughters and The Bill, we
              bring professional editing quality to your personal memories.
              <br />
              <br />
              We would love the opportunity to provide the same joy to you that we experienced that
              first time. And every time since.
            </p>
            <div className="trust-factors">
              <div className="trust-item">
                <h3>TV Production Pedigree</h3>
                <p>Credits include <em>McLeod's Daughters</em> and <em>The Bill</em></p>
              </div>
              <div className="trust-item">
                <h3>Safety First</h3>
                <p>Working With Children Check (WWCC) and Police Clearance</p>
              </div>
            </div>
          </div>
          <div className="about-photos">
            <div className="about-photo">
              <img src="/family-photos.png" alt="Family Photos" loading="lazy" />
            </div>
            <div className="about-photo edit-suite-photo">
              <img src="/edit-suite-image.png" alt="Editing Suite" loading="lazy" />
            </div>
          </div>
        </div>
        <div className="about-video">
          <h3>Our Kids' Vid</h3>
          <p className="video-intro">Snippets from the film that sparked the idea for Kids Vids.</p>
          <div className="video-wrapper">
            <iframe
              src="https://www.youtube.com/embed/p6rZmC2THfM"
              title="Sample Film"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="youtube-embed"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
